export const MAX_DISPLAYED_HOTSPOTS_COUNT = 10;